import { useMemo } from 'react';
import { cn } from '../../../lib/cn';
import { Combobox, type ComboboxOption } from '../../../ui/Combobox';
import { ClientDot } from '../../clients/components/ClientDot';
import { comboLabel, type LinkCombo } from '../hooks/useTimeOptions';

/**
 * Wybór „klient · projekt” (Figma 06: kropka koloru klienta + „HelpMyCar · Aplikacja”). Ostatnio używane
 * połączenia na górze listy; wyszukiwanie ignoruje polskie znaki (Combobox).
 */
export function LinkPicker({
  combos,
  value,
  onValueChange,
  disabled,
  loading,
  bare = false,
  id,
  className,
}: {
  combos: LinkCombo[];
  value: string;
  onValueChange: (key: string) => void;
  disabled?: boolean;
  loading?: boolean;
  /** bez ramki (pasek dodawania) */
  bare?: boolean;
  id?: string;
  className?: string;
}) {
  const options: ComboboxOption[] = useMemo(
    () =>
      combos.map((c) => ({
        value: c.key,
        label: comboLabel(c),
        description: c.recent ? 'ostatnio' : c.internal && c.projectName ? 'wewnętrzny' : undefined,
        leading: <ClientDot color={c.color} />,
        keywords: [c.clientName ?? '', c.projectName ?? ''],
      })),
    [combos],
  );
  return (
    <Combobox
      id={id}
      aria-label="Klient i projekt"
      value={value}
      onValueChange={onValueChange}
      options={options}
      placeholder={loading ? 'Wczytywanie…' : 'Klient · projekt'}
      searchPlaceholder="Szukaj klienta albo projektu…"
      emptyText="Brak klientów i projektów"
      disabled={disabled || loading}
      size={bare ? 's' : 'm'}
      className={cn(
        bare &&
          'w-auto max-w-[260px] border-transparent font-medium text-fg shadow-none hover:border-transparent hover:bg-surface',
        className,
      )}
    />
  );
}
